import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_are_paid_through_3rd_party_agents_have'

export const dataPointDefinition = {
  retracedId: 'workers_are_paid_through_3rd_party_agents_have',
  name: 'If workers are paid through 3rd party agents, have workers authorized this in writing?',
  description:
    'The intent of this question is to understand if there is written authorization in place in cases where 3rd party agents are responsible for wage payments of workers. ',
  meta: {
    slcpMeta: {
      key: 'wb-15--3',
      number: 'WB-WAGE-107',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-15--3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34920,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
